import { Link } from "@/components/catalyst/link";
import { localStorageKeys } from "@/lib/utils";

function handleChangeOrganisation() {
  localStorage.removeItem(localStorageKeys.GLOBAL_SUPPLIER);
  window.location.href = "/org";
}

export function NotFoundScreen() {
  return (
    <div className="grid min-h-full place-items-center bg-white px-3 py-24 sm:px-6 sm:py-32 lg:px-8">
      <div className="text-center">
        <p className="text-base font-semibold text-indigo-600">404</p>
        <h1 className="mt-4 text-3xl font-bold tracking-tight text-gray-900 sm:text-5xl">
          Page not found
        </h1>
        <p className="mt-6 text-base leading-7 text-gray-600">
          Sorry, we couldn&apos;t find the page you&apos;re looking for.
        </p>
        <div className="mt-10 flex items-center justify-center gap-x-6">
          <Link
            to="/"
            className="shadow-xs focus-visible:outline-solid rounded-md bg-indigo-600 px-3.5 py-2.5 text-sm font-semibold text-white hover:bg-indigo-500 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
          >
            Go back home
          </Link>
          <button
            onClick={handleChangeOrganisation}
            className="text-sm font-semibold text-gray-900"
          >
            Change organisation <span aria-hidden="true">&rarr;</span>
          </button>
        </div>
      </div>
    </div>
  );
}
